//
// Action Types
//

export const SET_ACTIVE_IDENTITY = 'consumer/memberships/SET_ACTIVE_IDENTITY';
export const TOGGLE_ALBUM_MEMBERSHIP_GROUP_FILTER =
  'consumer/memberships/TOGGLE_ALBUM_MEMBERSHIP_GROUP_FILTER';
export const CLEAR_ALBUM_MEMBERSHIP_GROUP_FILTERS =
  'consumer/memberships/CLEAR_ALBUM_MEMBERSHIP_GROUP_FILTERS';
export const SET_PENDING_PURCHASING_OPTION =
  'consumer/memberships/SET_PENDING_PURCHASING_OPTION';

//
// Action Creators
//

// General actions

export const setActiveIdentity = identity => ({
  type: SET_ACTIVE_IDENTITY,
  identity,
});

/**
 * Sets a pending cart item.
 *
 * @param {Object} item The cart item (ie PrintPackage, IndividualPricing, etc).
 * @returns {{item, type: string}}
 */
export const setPendingPurchasingOption = item => {
  return {
    type: SET_PENDING_PURCHASING_OPTION,
    item,
  };
};

export const toggleAlbumMembershipGroupFilter = albumFolderTagId => ({
  id: albumFolderTagId,
  type: TOGGLE_ALBUM_MEMBERSHIP_GROUP_FILTER,
});

export const clearAlbumMembershipGroupFilters = () => ({
  type: CLEAR_ALBUM_MEMBERSHIP_GROUP_FILTERS,
});
